import routes from '@modules/inscription/inscription-routes';
import store from '@modules/inscription/inscription-store';

export default {
    routes,
    store,
};